module.exports = __webpack_public_path__ + "static/media/blogbook.3c95acc0.svg";